import {  NARegion } from "@dana/Common/Constants";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";


const useIsNA = (state: ApplicationState): boolean => {
    const currentLanguage = state.context.session.language;
    const isNA = currentLanguage?.properties?.region === NARegion;
    return isNA;
};
export default useIsNA;

